import React from "react";
import webPageImage from "../../../../shared-library/assets/images/SalesJourney/Login/banner-page.png";
var ImagePage = function () {
    return (React.createElement("div", { className: "bg-midnight-blue heighthv flexCenter" },
        React.createElement("div", { className: "new-logo" },
            React.createElement("img", { src: webPageImage, alt: "nuvama" }))));
};
export default ImagePage;
